import {
  CompletedTransactionPage,
  FailedTransactionPage,
  HomePage,
  SendMoneyPage,
  ShowTransactionPage,
  TransactionsHistoryPage,
} from '@features/transaction/routes/lazy';
import { RouteObject } from 'react-router-dom';

export const TRANSACTION_ROUTES = {
  home: '/',
  sendMoney: '/send-money',
  show: '/show',
  transactionHistory: '/transaction-history',
  completedTransaction: '/completed-transaction',
  failedTransaction: '/failed-transaction',
};

export const transactionRouteObject: RouteObject = {
  path: '/',
  children: [
    {
      path: `/`,
      element: <HomePage />,
    },
    {
      path: TRANSACTION_ROUTES.sendMoney,
      element: <SendMoneyPage />,
    },
    {
      path: `${TRANSACTION_ROUTES.show}/:id`,
      element: <ShowTransactionPage />,
    },
    {
      path: TRANSACTION_ROUTES.transactionHistory,
      element: <TransactionsHistoryPage />,
    },
    {
      path: `${TRANSACTION_ROUTES.completedTransaction}/:id`,
      element: <CompletedTransactionPage />,
    },
    {
      path: TRANSACTION_ROUTES.failedTransaction,
      element: <FailedTransactionPage />,
    },
  ],
};
